export default __webpack_public_path__ + "static/media/cover-autolike.331aa67b.png";